import { Injectable } from '@angular/core';
import { AuthRolService } from '../../../core/services/auth-rol.service';

@Injectable({
  providedIn: 'root',
})
export class MoldAuthService extends AuthRolService {
  readonly addEditRoles = ['Chief', 'Admin'];
  add(): boolean {
    return this.lookForRolesNeeded(this.addEditRoles);
  }

  edit(): boolean {
    return this.lookForRolesNeeded(this.addEditRoles);
  }
  editName() {
    return this.lookForRolesNeeded(this.addEditRoles);
  }

  setStatus(): boolean {
    return this.lookForRolesNeeded(this.addEditRoles);
  }

  editLocation(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }

  // changeLocation(): boolean {
  //   return this.lookForRolesNeeded(['Chief', 'Admin']);
  // }
}
